import { render, staticRenderFns } from "./AppointmentDisplay.vue?vue&type=template&id=5749c252"
import script from "./AppointmentDisplay.vue?vue&type=script&lang=js"
export * from "./AppointmentDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports